import { DragEvent } from 'react'

import { WIDGET_DATA_TRANSFER_TYPE } from 'modules/desktop/pages/MainPage/MainPage.constants'
import { WidgetKey, WidgetSize } from 'shared/constants/widgets'
import { AiArtifactConfig, WidgetSpec } from 'shared/types/widgets'

import { DEFAULT_WIDGET_SIZE } from '../constants/widgetDimensions'

export type DroppedWidgetSpec = WidgetSpec & { config?: AiArtifactConfig }

export const readWidgetPayload = (
  event: DragEvent
): DroppedWidgetSpec | null => {
  const data = event.dataTransfer.getData(WIDGET_DATA_TRANSFER_TYPE)
  if (!data) return null

  try {
    const parsed = JSON.parse(data) as {
      type?: string
      widget?: { widgetKey: WidgetKey }
      sidePanelSize?: WidgetSize
      config?: AiArtifactConfig
    }

    if (parsed.type !== 'widget' || !parsed.widget?.widgetKey) {
      return null
    }

    return {
      widgetKey: parsed.widget.widgetKey,
      size: parsed.sidePanelSize ?? DEFAULT_WIDGET_SIZE,
      ...(parsed.config?.publicId ? { config: parsed.config } : {})
    }
  } catch {
    return null
  }
}
